/* import __COLOCATED_TEMPLATE__ from './io-voltage.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();